import React, { useEffect } from 'react';
import MuiDialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const Dialog: React.FC<DialogProps> = props => {
    const [opened, setOpened] = React.useState(false);

    useEffect(() => {
        if (!opened && props.open) {
            setOpened(true);
        }
    }, [opened, props.open]);

    if (!opened) {
        return <></>;
    }

    return (
        <MuiDialog
            onClick={ e => e.stopPropagation() }
            fullWidth
            onClose={ props.onCloseClick }
            open={ props.open }
            keepMounted={ props.keepMounted && opened }
            sx={ { '& .MuiDialog-paper': { maxWidth: '95%' } } }
        >
            <DialogTitle onCloseClick={ props.onCloseClick }>
                { props.title } &nbsp;
            </DialogTitle>
            { props.children }
        </MuiDialog>
    );
}
export default Dialog;


export interface DialogProps {
    readonly open: boolean;
    readonly onCloseClick: () => void;
    readonly title?: string;
    readonly children: React.ReactNode;
    readonly keepMounted?: boolean;
}

const DialogTitle = (props: DialogTitleProps) => {
    const { onCloseClick, children } = props;

    return (
        <MuiDialogTitle sx={ { m: 0, p: 2 } }>
            { children }
            <IconButton
                size="small"
                aria-label="close"
                onClick={ onCloseClick }
                sx={ {
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                } }
            >
                <CloseIcon fontSize='small'/>
            </IconButton>
        </MuiDialogTitle>
    );
};

export interface DialogTitleProps {
    children?: string | React.ReactNode;
    onCloseClick: () => void;
}


